module.exports = __webpack_public_path__ + "img/logicBg.aaa09280.png";